// AssessmentList.jsx
import React, { useState } from "react";

const TOOL_ICONS = {
  google_search: (size = 18) => (
    <svg
        viewBox="-3 0 262 262"
        xmlns="http://www.w3.org/2000/svg"
        preserveAspectRatio="xMidYMid"
        fill="#000000"
        >
        <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
        <g
            id="SVGRepo_tracerCarrier"
            strokeLinecap="round"
            strokeLinejoin="round"
        ></g>
        <g id="SVGRepo_iconCarrier">
            <path
            d="M255.878 133.451c0-10.734-.871-18.567-2.756-26.69H130.55v48.448h71.947c-1.45 12.04-9.283 30.172-26.69 42.356l-.244 1.622 38.755 30.023 2.685.268c24.659-22.774 38.875-56.282 38.875-96.027"
            fill="#4285F4"
            ></path>
            <path
            d="M130.55 261.1c35.248 0 64.839-11.605 86.453-31.622l-41.196-31.913c-11.024 7.688-25.82 13.055-45.257 13.055-34.523 0-63.824-22.773-74.269-54.25l-1.531.13-40.298 31.187-.527 1.465C35.393 231.798 79.49 261.1 130.55 261.1"
            fill="#34A853"
            ></path>
            <path
            d="M56.281 156.37c-2.756-8.123-4.351-16.827-4.351-25.82 0-8.994 1.595-17.697 4.206-25.82l-.073-1.73L15.26 71.312l-1.335.635C5.077 89.644 0 109.517 0 130.55s5.077 40.905 13.925 58.602l42.356-32.782"
            fill="#FBBC05"
            ></path>
            <path
            d="M130.55 50.479c24.514 0 41.05 10.589 50.479 19.438l36.844-35.974C195.245 12.91 165.798 0 130.55 0 79.49 0 35.393 29.301 13.925 71.947l42.211 32.783c10.59-31.477 39.891-54.251 74.414-54.251"
            fill="#EB4335"
            ></path>
        </g>
        </svg>
  ),
  search_knowledge_base: (size = 18) => (
    <svg
            version="1.1"
            id="Icons"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            viewBox="0 0 32 32"
            xmlSpace="preserve"
            fill="#000000"
          >
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g
              id="SVGRepo_tracerCarrier"
              strokeLinecap="round"
              strokeLinejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
              <style type="text/css">
                {`.st0{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}`}
              </style>
              <path
                className="st0"
                d="M26,3H9C7.3,3,6,4.3,6,6v0c0,1.7,1.3,3,3,3h17v10"
              ></path>
              <path className="st0" d="M18,29H9c-1.7,0-3-1.3-3-3v0V6"></path>
              <line className="st0" x1="26" y1="6" x2="9" y2="6"></line>
              <line className="st0" x1="10" y1="9" x2="10" y2="29"></line>
              <path
                className="st0"
                d="M25.5,18.5c1.9,1.9,1.9,5.1,0,7c-0.5,0.5-1,0.8-1.6,1.1c-1.8,0.7-3.9,0.4-5.4-1.1c-1.9-1.9-1.9-5.1,0-7 S23.6,16.6,25.5,18.5z"
              ></path>
              <path
                className="st0"
                d="M26.5,24l3.9,3.6c0.8,0.8,0.8,2,0,2.8l0,0c-0.8,0.8-2,0.8-2.8,0l-3.5-3.5"
              ></path>
            </g>
          </svg>
  ),
};

const DefaultIcon = ({ size = 18 }) => (
  <svg
            height="200px"
            width="200px"
            version="1.1"
            id="Capa_1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            viewBox="0 0 393.535 393.535"
            xmlSpace="preserve"
            fill="#000000"
          >
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g
              id="SVGRepo_tracerCarrier"
              strokeLinecap="round"
              strokeLinejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
              {" "}
              <g>
                {" "}
                <path
                  style={{ fill: "#000000" }}
                  d="M380.973,316.791l-48.656-48.654c5.891-15.474,8.131-32.307,6.361-48.939 c-2.539-23.875-13.283-46.37-30.252-63.339c-8.418-8.417-18.018-15.228-28.426-20.292V77.111c0-3.934-1.56-7.706-4.344-10.484 l-58.875-58.88c-2.785-2.778-6.551-4.339-10.484-4.339H29.111C13.059,3.408,0,16.468,0,32.521v312.095 c0,16.053,13.059,29.113,29.111,29.113h221.777c16.053,0,29.111-13.06,29.111-29.113v-7.29l40.219,40.219 c8.115,8.114,18.902,12.582,30.377,12.582s22.262-4.469,30.377-12.582C397.723,360.794,397.723,333.541,380.973,316.791z M248.387,341.315H31.613V35.822h154.088v43.577c0,10.554,8.555,19.106,19.105,19.106h43.58v27.496 c-4.775-0.652-9.625-0.992-14.531-0.992c-28.191,0-54.676,10.956-74.568,30.85c-19.895,19.894-30.85,46.376-30.85,74.569 c0,28.193,10.955,54.676,30.85,74.569c19.893,19.894,46.373,30.85,74.566,30.85c4.887,0,9.74-0.336,14.533-0.997V341.315z M364.188,359.534c-7.014,7.014-18.385,7.014-25.398,0l-61.277-61.278c-31.064,19.492-72.648,15.738-99.654-11.269 c-31.371-31.37-31.371-82.413,0-113.783c31.369-31.37,82.412-31.37,113.783,0c27.006,27.006,30.76,68.591,11.268,99.654 l61.279,61.278C371.201,341.149,371.201,352.52,364.188,359.534z"
                ></path>{" "}
                <path
                  style={{ fill: "#000000" }}
                  d="M202.914,198.261c-17.554,17.554-17.554,46.115,0,63.669c17.554,17.553,46.114,17.553,63.67,0 c17.552-17.554,17.552-46.115,0-63.669C249.028,180.707,220.468,180.707,202.914,198.261z"
                ></path>{" "}
              </g>{" "}
            </g>
          </svg>
);

const CircularWithIcon = ({
  percent,
  tool,
  size = 52,
  strokeWidth = 6,
  onEnter,
  onLeave,
  onFocus,
  onBlur
}) => {
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (percent / 100) * circumference;

  const color = percent >= 60 ? "#28a745" : percent >= 40 ? "#ffc107" : "#dc3545";

  const Icon = TOOL_ICONS[tool];

  const renderInner = () => {
    if (Icon) return Icon(Math.round(size * 0.35));
    if (tool) {
      const initials = tool
        .split(/[_\s-]+/)
        .map((w) => w[0])
        .slice(0, 2)
        .join("")
        .toUpperCase();
      return <span style={{ fontSize: size * 0.30, fontWeight: 700 }}>{initials}</span>;
    }
    return <DefaultIcon size={size * 0.35} />;
  };

  return (
    <div
      style={{
        width: size,
        height: size,
        position: "relative",
        display: "inline-block",
      }}
      onMouseEnter={onEnter}
      onMouseLeave={onLeave}
      onFocus={onFocus}
      onBlur={onBlur}
      tabIndex={0}
    >
      <svg
        width={size}
        height={size}
        viewBox={`0 0 ${size} ${size}`}
        style={{ transform: "rotate(-90deg)" }}
      >
        <circle cx={size / 2} cy={size / 2} r={radius} stroke="#e9ecef" strokeWidth={strokeWidth} fill="transparent" />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          stroke={color}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          fill="transparent"
        />
      </svg>

      <div
        style={{
          position: "absolute",
          inset: 0,
          display: "flex",
          alignItems: "center",
          left: 15,
          width: 20,
          justifyContent: "center",
        }}
      >
        {renderInner()}
      </div>
    </div>
  );
};

export default function AssessmentList({ searchEvaluation, documents }) {
  const [hoverIndex, setHoverIndex] = useState(null);

  if (!searchEvaluation || searchEvaluation.length === 0) {
    return <span style={{ color: "#6c757d" }}>No assessment</span>;
  }

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
      {searchEvaluation.map((seval, idx) => {
        const confidencePercent = Math.round((seval.confidence || 0) * 100);

        const showTooltip = hoverIndex === idx;

        const docsForThisItem =
          seval.tool_used === "search_knowledge_base"
            ? (documents || [])
            : [];

        return (
          <div
            key={idx}
            style={{
              display: "flex",
              flexDirection: "column",
              gap: 6,
              position: "relative",
              padding: "6px 2px",
            }}
          >
            {/* Top row: icon + query */}
            <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
              <CircularWithIcon
                percent={confidencePercent}
                tool={seval.tool_used}
                size={48}
                strokeWidth={5}
                onEnter={() => setHoverIndex(idx)}
                onLeave={() => setHoverIndex(null)}
                onFocus={() => setHoverIndex(idx)}
                onBlur={() => setHoverIndex(null)}
              />

              <div style={{ display: "flex", flexDirection: "column" }}>
                <div style={{ fontSize: 11, color: "#6c757d", marginBottom: 4 }}>
                  {seval.query}
                </div>
              </div>
            </div>

            {/* NEW — documents shown below the query */}
            {docsForThisItem.length > 0 && (
              <div className="sources-list" style={{ marginLeft: 60 }}>
                {docsForThisItem.map((doc, d) => (
                  <div key={d} className="source-item" style={{ marginBottom: 4 }}>
                    <a
                      href={doc.document_url}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ textDecoration: "none", fontSize: 11, color: "#6c757d", marginBottom: 4  }}
                    >
                      {doc.document_title || doc.document_url}
                      <svg
                        style={{
                          marginLeft: 4,
                          width: 12,
                          height: 12,
                          verticalAlign: "middle",
                        }}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                      >
                        <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
                        <polyline points="15 3 21 3 21 9"></polyline>
                        <line x1="10" y1="14" x2="21" y2="3"></line>
                      </svg>
                    </a>
                  </div>
                ))}
              </div>
            )}

            {/* Tooltip (hover icon) */}
            {showTooltip && (
              <div
                style={{
                  position: "absolute",
                  left: 64,
                  top: 4,
                  zIndex: 9999,
                  minWidth: 220,
                  background: "#fff",
                  border: "1px solid rgba(0,0,0,0.12)",
                  padding: 10,
                  borderRadius: 8,
                  boxShadow: "0 6px 18px rgba(0,0,0,0.08)",
                }}
              >
                <strong>{seval.tool_used || "Unknown tool"}</strong>
                <div style={{ marginTop: 6 }}>
                  <strong>Query:</strong>
                  <div style={{ marginTop: 4 }}>{seval.query}</div>
                </div>
                <div style={{ marginTop: 6 }}>
                  <strong>Assessment:</strong>
                  <div style={{ marginTop: 4 }}>{seval.assessment}</div>
                </div>
              </div>
            )}
          </div>
        );
      })}

      
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/ai/AssessmentList.js